module.exports = __webpack_public_path__ + "media/images/Trophy-d20d1a4b4667b3d14f44feaf2042646c.png";